import get from 'lodash.get';

const getMaxDomainDiscount = (currency, packagePrices) => {
  const domainPrices = get(packagePrices, `domain`, null);
  if (!domainPrices) return null;

  const discounts = Object.keys(domainPrices).map((tld) => {
    const prices = get(domainPrices[tld], `P1Y.prices`, {});

    const basePrice = get(prices, `base.${currency}`, null);
    const discountPrice = get(prices, `discounted.${currency}`, null);
    if (basePrice === null || discountPrice === null) return 0;

    return basePrice - discountPrice;
  });

  return Math.max(...discounts, 0);
};

export default getMaxDomainDiscount;
